import React from 'react';
import SubPage from '../components/site/SubPage';
import { PageSection, PageTitleImage, RuledHeading } from '../components/site/SubPageParts';

const IMG = '/images/site/company';

const PARTNERS = [
  {
    name: 'Operation Shamrock',
    href: 'https://www.operationshamrock.org/',
    body: 'Focuses on educating and mobilizing against transnational organized crime syndicates that are stealing tens of billions of dollars, household by household, in sophisticated targeted scams of unprecedented frequency and magnitude.',
  },
  {
    name: 'FightCybercrime',
    href: 'https://fightcybercrime.org/',
    // The mockup repeated Operation Shamrock's paragraph here; this is a
    // placeholder until real copy lands.
    body: 'Helps people recognize, report and recover from scams and cybercrime through free education and victim support resources.',
  },
];

const ResourcesPage = () => (
  <SubPage title="Resources">
    <PageTitleImage
      src={`${IMG}/resources-hero.jpeg`}
      alt="An older man smiling at a tablet against a blue backdrop"
      color="#111111"
      // He stands at the right of the frame; centred, the phone crop loses him.
      focus="object-right lg:object-center"
    >
      Resources
    </PageTitleImage>

    <PageSection className="pt-10">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-[minmax(0,34%)_minmax(0,1fr)] md:gap-16">
        {/* Indented to sit under the hero title rather than out at the section
            edge, which left the two on different verticals. */}
        <div className="md:pl-10">
          <RuledHeading>User Notice.</RuledHeading>
          <p className="mt-5 text-[15px] leading-relaxed text-black md:text-[17px]">
            NuVola AI &ldquo;No / SCAM&rdquo; does not endorse, has not verified, and is not
            responsible for any content, views, products, services, or user policies. They are
            provided as educational reference.
          </p>
        </div>

        <div>
          <RuledHeading>Partner in the fight.</RuledHeading>
          <ul className="mt-5 space-y-8">
            {PARTNERS.map((partner) => (
              <li key={partner.name}>
                <h3 className="text-[17px] text-black md:text-[19px]">{partner.name}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-black md:text-[17px]">
                  {partner.body}
                </p>
                <a
                  href={partner.href}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-2 flex justify-end text-[22px] text-black hover:text-[#0A6EA8]"
                  aria-label={`Visit ${partner.name}`}
                >
                  &rarr;
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </PageSection>
  </SubPage>
);

export default ResourcesPage;
